import { render, staticRenderFns } from "./sidebar-wrapper.vue?vue&type=template&id=99e5bbcc&scoped=true&"
import script from "./sidebar-wrapper.vue?vue&type=script&lang=js&"
export * from "./sidebar-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-wrapper.vue?vue&type=style&index=0&id=99e5bbcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e5bbcc",
  null
  
)

export default component.exports